import React, { useState, useEffect, useRef } from 'react';
import { useLocation, useNavigate, Link } from 'react-router-dom';
import { auth, db } from './firebase';
import { doc, getDoc } from 'firebase/firestore';
import { signOut } from 'firebase/auth';
import { Settings as SettingsIcon, LogOut } from 'lucide-react';
import Sidebar from './Sidebar'; // Sidebar আলাদা ফাইলে থাকলে সেটি ইমপোর্ট হবে

const Layout = ({ children }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const user = auth.currentUser;
  const [photoURL, setPhotoURL] = useState('');
  const [menuOpen, setMenuOpen] = useState(false);
  const menuRef = useRef(null);

  // Profile photos are saved in Firestore (see Settings.js), not Auth's photoURL
  useEffect(() => {
    if (!user) return;
    getDoc(doc(db, "userProfiles", user.uid)).then((snap) => {
      if (snap.exists() && snap.data().photoURL) setPhotoURL(snap.data().photoURL);
    });
  }, [user]);

  // প্রোফাইল ছবির বাইরে ক্লিক করলে ড্রপডাউন বন্ধ হয়ে যাবে
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) setMenuOpen(false);
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleLogout = () => {
    if (window.confirm("Logout from system?")) {
      signOut(auth).then(() => navigate('/login'));
    }
  };

  // পেজের টাইটেল নির্ধারণ (অটোমেটিক মেনু নাম অনুযায়ী)
  const getPageTitle = () => {
    const titles = {
      '/': 'Dashboard',
      '/sales': 'Sales Management',
      '/purchase': 'Purchase & Stock In',
      '/saree-setup': 'Product Setup',
      '/accounts': 'Accounts & Ledger',
      '/stock': 'Current Stock',
      '/contacts': 'Customer & Supplier',
      '/recycle-bin': 'Recycle Bin',
      '/settings': 'Settings',
      '/reports': 'Master Reports',
      '/import': 'Import Data'
    };
    return titles[location.pathname] || 'Kizuna Inventory';
  };

  return (
    <div className="app-container">
      {/* বাম পাশের সাইডবার */}
      <Sidebar />

      {/* ডান পাশের মেইন এরিয়া */}
      <div className="main-content">
        {/* টপ নেভিগেশন বার */}
        <div className="top-nav">
          <h2 style={{ fontSize: '20px', margin: 0 }}>{getPageTitle()}</h2>
          
          <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
            <div style={{ textAlign: 'right' }}>
              <p style={{ margin: 0, fontWeight: 'bold', fontSize: '14px', color: '#333' }}>
                {user?.displayName || "Sohan"}
              </p>
              <p style={{ margin: 0, fontSize: '10px', color: '#888' }}>
                {user?.email || "admin@kizuna.com"}
              </p>
            </div>

            {/* --- ছবি এখানে ঠিক করা হয়েছে --- */}
            <div ref={menuRef} style={{ position: 'relative' }}>
            <div
              onClick={() => setMenuOpen(o => !o)}
              style={{ width: '42px', height: '42px', borderRadius: '50%', overflow: 'hidden', border: '2px solid #fff', boxShadow: '0 2px 10px rgba(0,0,0,0.1)', cursor: 'pointer' }}
            >
              <img 
                src={photoURL || "https://api.dicebear.com/7.x/avataaars/svg?seed=Sohan"}
                alt="Profile"
                style={{
                  width: '100%', 
                  height: '100%', 
                  objectFit: 'cover', // এটি ছবিকে গোল রাখবে, চেপ্টা করবে না
                  display: 'block'
                }}
                onError={(e) => { e.target.src = `https://ui-avatars.com/api/?name=${user?.displayName || 'Sohan'}&background=4a00e0&color=fff`; }}
              />
            </div>

              {menuOpen && (
                <div className="profile-dropdown">
                  <Link to="/settings" onClick={() => setMenuOpen(false)} className="profile-dropdown-item">
                    <SettingsIcon size={16} /> Settings
                  </Link>
                  <button onClick={handleLogout} className="profile-dropdown-item logout">
                    <LogOut size={16} /> Logout
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>

        {/* অ্যাপের কন্টেন্ট এরিয়া */}
        <div className="content-area" style={{ padding: '20px' }}>
          {children}
        </div>
      </div>
    </div>
  );
};

export default Layout;